module.exports = __webpack_public_path__ + "assets/img/Disallowed Goal.webp?1b22d7ec89c34f206ecc1a6eea9ed17a";